import React from 'react';
import { useSelector } from 'react-redux';

import { metaKeySelector } from 'features/superBatchManagement';
import CoursePauseInputs from './CoursePauseInputs';
import RibbonInputs from './RibbonInputs';

function InputRenderer() {
  const metaKey = useSelector(metaKeySelector);

  switch (metaKey?.value) {
    case 'future_dated_pause_request_enabled':
    case 'back_dated_pause_request_enabled':
      return <CoursePauseInputs />;
    case 'ribbon_data':
      return <RibbonInputs />;
    default:
      return null;
  }
}

export default InputRenderer;
